import interpolate from 'color-interpolate'
import gsap from 'gsap'
import store from '@/store'
import { playUnlock } from '@/lib/sound.js'

let path_def
let button_gap
let button_span

function setupPath() {
  const button_pos = document.getElementById('button-8').getBoundingClientRect()
  const left_button_pos = document
    .getElementById('button-7')
    .getBoundingClientRect()

  button_gap = button_pos.x - (left_button_pos.x + left_button_pos.width)
  button_span = button_pos.width

  path_def = [
    [
      { x: 0, y: 0 },
      { x: 0, y: button_span + button_gap },
    ],
    [
      { x: 0, y: button_span + button_gap },
      {
        x: -2 * button_gap - 2 * button_span,
        y: button_span + button_gap,
      },
    ],
    [
      {
        x: -2 * button_gap - 2 * button_span,
        y: button_span + button_gap,
      },
      {
        x: -2 * button_gap - 2 * button_span,
        y: -3 * button_gap - 3 * button_span,
      },
    ],
    [
      {
        x: -2 * button_gap - 2 * button_span,
        y: -3 * button_gap - 3 * button_span,
      },
      {
        x: 0,
        y: -3 * button_gap - 3 * button_span,
      },
    ],
  ]
}

function isOffsetOnLine(offset, v) {
  const epsilon = 0.5
  const onX =
    offset.x >= Math.min(v[0].x, v[1].x) - epsilon &&
    offset.x <= Math.max(v[0].x, v[1].x) + epsilon
  const onY =
    offset.y >= Math.min(v[0].y, v[1].y) - epsilon &&
    offset.y <= Math.max(v[0].y, v[1].y) + epsilon
  return onX && onY
}

function findLines(offset) {
  return path_def.filter((v) => isOffsetOnLine(offset, v))
}

function distance(offset) {
  let line_index = path_def
    .map((v) => isOffsetOnLine(offset, v))
    .findIndex((x) => x)
  if (line_index == -1) {
    return 0
  }

  const total_distance = path_def.reduce((s, p) => {
    let v = [p[1].x - p[0].x, p[1].y - p[0].y]
    return Math.sqrt(v[0] ** 2 + v[1] ** 2) + s
  }, 0)

  let distance = 0

  for (let i = 0; i < line_index; i++) {
    let v = [
      path_def[i][1].x - path_def[i][0].x,
      path_def[i][1].y - path_def[i][0].y,
    ]
    distance += Math.sqrt(v[0] ** 2 + v[1] ** 2)
  }
  //console.log('base distance: ', distance)

  let final_v = [
    offset.x - path_def[line_index][0].x,
    offset.y - path_def[line_index][0].y,
  ]
  distance += Math.sqrt(final_v[0] ** 2 + final_v[1] ** 2)

  //console.log('final distance: ', distance)

  return distance / total_distance
}

function dotProduct(v1, v2) {
  return v1.x * v2.x + v1.y * v2.y
}

// https://en.wikipedia.org/wiki/Vector_projection
// project a onto b
function vectorProject(a, b) {
  const scalar = dotProduct(a, b) / dotProduct(b, b)
  let v = Object.assign({}, b)
  v.x = scalar * v.x
  v.y = scalar * v.y
  return v
}

function projectOntoLine(m, l) {
  let line_vec = { x: l[0].x - l[1].x, y: l[0].y - l[1].y }
  return vectorProject(m, line_vec)
}

function updateButtonStyle(button, x_delta, y_delta, colour) {
  button.style.transform = `translate(${x_delta}px, ${y_delta}px)`
  button.style.color = colour
  button.style.borderColor = colour
}

/*function resetButtonStyle(button) {
  button.style.transform = null
  button.style.transformOrigin = null
  button.style.color = null
  button.style.borderColor = null
}*/

function roundtheoutside(event) {
  const colormap = interpolate(['#cdf4dd', '#468B18'])
  setupPath()
  console.log(path_def)

  let clientX =
    event.type == 'touchstart' ? event.changedTouches[0].clientX : event.clientX
  let clientY =
    event.type == 'touchstart' ? event.changedTouches[0].clientY : event.clientY

  let offset = { x: 0, y: 0 }

  const move_listener = function (e) {
    let newClientX =
      e.type == 'touchmove' ? e.changedTouches[0].clientX : e.clientX
    let newClientY =
      e.type == 'touchmove' ? e.changedTouches[0].clientY : e.clientY

    //console.log(newClientX, newClientY)

    let movement = { x: newClientX - clientX, y: newClientY - clientY }
    let lines = findLines(offset)
    let projections = lines.map((l) => projectOntoLine(movement, l))
    let projection_lengths = projections.map((p) => Math.sqrt(dotProduct(p, p)))
    let longest_projection =
      projections[
        projection_lengths.findIndex(
          (x) => x == Math.max(...projection_lengths)
        )
      ]

    //console.log('On lines: ', lines.length)
    /*console.log('Offset: ', offset)
    console.log('On lines: ', lines.length)
    console.log('Movement: ', movement)
    console.log('Longest projection: ', longest_projection)
    console.log('')*/

    let potentialOffset = {
      x: offset.x + longest_projection.x,
      y: offset.y + longest_projection.y,
    }
    if (findLines(potentialOffset).length > 0) {
      offset = potentialOffset
    }
    //console.log('Offset: ', offset)
    //console.log('distance: ', distance(offset))

    let distance_travelled = distance(offset)

    store.commit('SET_UNLOCK_PROGRESS', distance_travelled * 100)

    updateButtonStyle(
      document.getElementById('button-8'),
      offset.x,
      offset.y,
      colormap(distance_travelled)
    )

    if (distance_travelled >= 1) {
      console.log('triggered!')
      window.removeEventListener('mousemove', move_listener)
      window.removeEventListener('mouseup', mouseup_listener)
      window.removeEventListener('touchmove', move_listener)
      window.removeEventListener('touchend', mouseup_listener)
      triggered()
    }

    clientX = newClientX
    clientY = newClientY
  }

  window.addEventListener('mousemove', move_listener)
  window.addEventListener('touchmove', move_listener)

  const mouseup_listener = function () {
    console.log('mouseup')
    window.removeEventListener('mousemove', move_listener)
    window.removeEventListener('mouseup', mouseup_listener)
    window.removeEventListener('touchmove', move_listener)
    window.removeEventListener('touchend', mouseup_listener)

    const tl = gsap.timeline()
    store.commit('SET_UNLOCK_PROGRESS', 0)

    tl.to('#button-8', {
      scale: 0,
      duration: 0.3,
    })
    tl.set('#button-8', {
      x: 0,
      y: 0,
      color: '#cdf4dd',
      borderColor: '#cdf4dd',
    })
    tl.to('#button-8', {
      scale: 1,
      duration: 0.3,
      clearProps: true,
      onComplete: () => {
        //resetButtonStyle(document.getElementById('button-8'))
        resetAllButtons()
      },
    })
  }
  window.addEventListener('mouseup', mouseup_listener)
  window.addEventListener('touchend', mouseup_listener)
}

function triggered() {
  let unlocking = !store.getters.isActionUnlocked('roundtheoutside')
  store.commit('SET_BLOCK_CLICKS', [1, 2, 3, 4, 5, 6, 7, 8, 9])

  if (unlocking) {
    playUnlock()
  } else {
    store.commit(
      'SET_MOVE_NAME_ANIMATE',
      store.getters.actions['roundtheoutside']
    )
  }

  setTimeout(() => {
    store.commit('SET_UNLOCK_PROGRESS', 0)
  }, 200)

  updateButtonStyle(
    document.getElementById('button-8'),
    path_def[path_def.length - 1][1].x,
    path_def[path_def.length - 1][1].y,
    '#468B18'
  )

  const tl = gsap.timeline()

  tl.to('#button-8', {
    color: '#cdf4dd',
    borderColor: '#cdf4dd',
    duration: 1,
    delay: unlocking ? 1 : 0,
  })

  tl.fromTo(
    '#button-8',
    { y: path_def[path_def.length - 1][1].y },
    {
      y: path_def[path_def.length - 1][1].y + button_span + button_gap,
      duration: 0.5,
      clearProps: true,
    },
    'final_shift'
  )

  tl.to(
    ['#button-2', '#button-5'],
    {
      y: button_span + button_gap,
      duration: 0.5,
      clearProps: true,
      onComplete: () => {
        let new_vals = [...store.getters.button_vals]
        const old_four = new_vals[4]

        new_vals[4] = new_vals[1]
        new_vals[1] = new_vals[7]
        new_vals[7] = old_four

        store.commit('SET_BUTTON_VALS', new_vals)
        store.commit('SET_CODE_SCREEN', 'CodeScreenBase')
        resetAllButtons()
        if (unlocking) {
          store.dispatch('unlock_action', 'roundtheoutside')
          setTimeout(() => {
            store.commit('SET_SHOW_UNLOCK_DIALOG', true)
          }, 500)
        } else {
          store.commit('SET_BLOCK_CLICKS', [])
        }
      },
    },
    'final_shift'
  )
}

function resetAllButtons() {
  const button_ids = [
    'button-1',
    'button-2',
    'button-3',
    'button-4',
    'button-5',
    'button-6',
    'button-7',
    'button-8',
    'button-9',
  ]
  button_ids.forEach((b) => resetButtonStyle(b))
}

function resetButtonStyle(button_id) {
  const button = document.getElementById(button_id)
  gsap.set(button, { clearProps: 'all' })
}

export default roundtheoutside
